import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../styles/styles.css';

const Footer = () => {
  const navigate = useNavigate();

  const handleLinkClick = () => {
    // Scroll to top with smooth behavior
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return (
    <footer id="footer">
      <div className="footer-top">
        <div className="footer-container">
          <div className="footer-grid">
            <div className="footer-column">
              <div className="footer-info">
                <h3>vinfocloud<span>SOFTWARE & IT STAFFING</span></h3>
                <p>
                  Providing expert software services and IT staffing solutions 
                  to help businesses achieve their technology goals.
                </p>
              </div>
            </div>

            <div className="footer-column">
              <div className="footer-links">
                <h4>Quick Links</h4>
                <ul>
                  <li><Link to="/" onClick={handleLinkClick}><i className="fa fa-chevron-right"></i> Home</Link></li>
                  <li><Link to="/services" onClick={handleLinkClick}><i className="fa fa-chevron-right"></i> Services</Link></li>
                  <li><Link to="/about" onClick={handleLinkClick}><i className="fa fa-chevron-right"></i> About Us</Link></li>
                  <li><Link to="/contact" onClick={handleLinkClick}><i className="fa fa-chevron-right"></i> Contact Us</Link></li>
                </ul>
              </div>
            </div>

            <div className="footer-column">
              <div className="footer-contact">
                <h4>Contact Us</h4>
                <p>
                  6250 Westpark Dr, Suite 319<br />
                  Houston, TX 77057<br />
                  United States <br />
                  <strong>Email:</strong> contactus@vinfocloud.com<br />
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className="footer-container-dowm">
        <div className="copyright">
          &copy; Copyright <strong>vinfocloud</strong>. All Rights Reserved
        </div>
      </div>
    </footer>
  );
};

export default Footer;